<div class="container-fluid">
  <div>
    <div class="row pt-4" style="margin-left:5px; font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <i class="fa fa-bullhorn mt-2" style="color:#800000"></i> &nbsp;&nbsp;
      <h5 class="modal-title mt-1" id="modal-basic-title">Announcements</h5>
    </div>
  </div>
  <div id="mainContent" class="container">
    <div class="row pt-3" *ngIf="hasAccess('Add New Announcement')">
      <div class="col-md-6">
        <div style="cursor: pointer; " (click)="onModalClick(modalContent)">
          <!-- <i class="fa fa-plus-square-o" aria-hidden="true" ></i>
      <span class="ml-2">Add New Announcement</span> -->
          <button class="btn btn-xs btn-theme"><i class="fa fa-plus-square-o" aria-hidden="true"></i>&nbsp;Add New
            Announcement</button>
        </div>
      </div>
      <div class="col-md-6 ">

      </div>
    </div>

    <div class="pt-3 pb-1">
  <table
    class="table table-striped table-bordered"
    style="width: 100%; table-layout: fixed;"
  >
    <thead>
      <tr>
        <th scope="col" width="20%">Announcement</th>
        <th scope="col" width="72%">Details</th>
        <th
          *ngIf="hasAccess('Add New Announcement')"
          scope="col"
          width="8%">
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let data of announcementList">

        <td width="20%">
          {{ data.announcementName }}
        </td>

        <td
          width="72%"
          style="
            white-space: pre-wrap;
            overflow-wrap: anywhere;
            word-break: break-word;
          "
        >
          <div
            [innerHTML]="data.announcementDetails"
            style="max-width: 100%; overflow-wrap: anywhere; word-break: break-word;"
          >
          </div>

          <a
            *ngIf="data.announcementUrl"
            [href]="data.announcementUrl"
            target="_blank"
            rel="noopener noreferrer"
            style="overflow-wrap: anywhere; word-break: break-all;"
          >
            {{ data.announcementUrl }}
          </a>

          <!-- Attachment -->
          <div *ngIf="data.url != null">

            <ng-container
              *ngIf="
                data.fileType == 'jpg' ||
                data.fileType == 'jpeg' ||
                data.fileType == 'png';
                else other_content
              "
            >
              <img
                [src]="data.url"
                style="
                  display: block;
                  max-width: 100%;
                  height: auto;
                "
              />
            </ng-container>

            <ng-template #other_content>
              <a
                [href]="data.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  class="fa fa-download fa-3x"
                  aria-hidden="true">
                </i>
                <br />
              </a>

              <span>{{ data.imageName }}</span>
            </ng-template>

          </div>
        </td>

        <!-- Edit/Delete -->
        <td
          *ngIf="hasAccess('Add New Announcement')"
          width="8%"
          style="text-align: center; vertical-align: top;"
        >
          <i
            class="fa fa-edit fa-lg"
            (click)="onEditClick(data, modalContent)"
            aria-hidden="true"
            style="cursor: pointer;"
          ></i>

          &nbsp;

          <i
            class="fa fa-trash fa-lg"
            (click)="onDeleteClick(data)"
            aria-hidden="true"
            style="cursor: pointer;"
          ></i>
        </td>

      </tr>

      <tr *ngIf="announcementList.length == 0">
        <td
          [attr.colspan]="hasAccess('Add New Announcement') ? 3 : 2"
          style="text-align: center;"
        >
          No Announcement Available
        </td>
      </tr>

    </tbody>
  </table>
</div>

  </div>
</div>
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title mt-2 mb-2" id="modal-basic-title">Add New Announcement</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body">
    <form [formGroup]="announcementForm">
      <div class="row">
        <label class="col-sm-3">Announcement :</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" formControlName="announcement" />
          <div class="mt-1">
            <div *ngIf="
                announcementForm.controls['announcement'].touched &&
                announcementForm.controls['announcement'].invalid
              ">
              <div *ngIf="
                  announcementForm.controls['announcement'].errors &&
                  announcementForm.controls['announcement'].errors.required
                ">
                <span style="color: red">Announcement is required.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div>   
         <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="htmlContent" [config]="config" [ngModelOptions]="{standalone: true}"></angular-editor>
      </div>
      <div>{{htmlContent|json}}</div> -->

      <div class="row mt-3">
        <label class="col-sm-3">Details :</label>
        <div class="col-sm-9">
          <angular-editor [placeholder]="'Enter text here...'" formControlName="details"
            [config]="config"></angular-editor>
          <!-- <textarea
            style="overflow: auto; resize: none"
            rows="9"
            cols="20"
            id="details"
            name="details"
            type="text"
            class="form-control form-control-xs"
            formControlName="details"
          >
          </textarea> -->
          <div class="mt-1">
            <div *ngIf="
                announcementForm.controls['details'].touched &&
                announcementForm.controls['details'].invalid
              ">
              <div *ngIf="
                  announcementForm.controls['details'].errors &&
                  announcementForm.controls['details'].errors.required
                ">
                <span style="color: red">Details are required.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3">
        <label class="col-sm-3">Details :</label>
        <div class="col-sm-9">
          <textarea
            style="overflow: auto; resize: none"
            rows="9"
            cols="20"
            id="details"
            name="details"
            type="text"
            class="form-control form-control-xs"
            formControlName="details"
          >
          </textarea>
          <div class="mt-1">
            <div
              *ngIf="
                announcementForm.controls['details'].touched &&
                announcementForm.controls['details'].invalid
              "
            >
              <div
                *ngIf="
                  announcementForm.controls['details'].errors &&
                  announcementForm.controls['details'].errors.required
                "
              >
                <span style="color: red">Details are required.</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row mt-3" >
        <label class="col-sm-3">URL:</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            formControlName="announcementUrl"
          />
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-sm-3">Expires Date :</label>
        <div class="col-sm-4">
          <div class="input-group">
            <input class="form-control datePickerStyle" placeholder="dd/mm/yyyy" name="expireDate" ngbDatepicker
              #expireDate="ngbDatepicker" formControlName="expireDate" [placement]="'bottom'" [minDate]="minDate" />
            <div class="input-group-append">
              <button class="btn btn-outline-theme calendar" (click)="expireDate.toggle()" type="button">
                <i class="fa fa-calendar"></i></button>

            </div>
          </div>
          <div class="mt-1">
            <div *ngIf="
                announcementForm.controls['expireDate'].touched &&
                announcementForm.controls['expireDate'].invalid
              ">
              <div *ngIf="
                  announcementForm.controls['expireDate'].errors &&
                  announcementForm.controls['expireDate'].errors.required
                ">
                <span style="color: red">Expire date is required.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-sm-3">
          <label>Select File :</label>
        </div>
        <div class="col-sm-9">
          <input #file type="file" formControlName="imageUrl"
            accept="image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf,.xls,.xlsx" placeholder="Upload file"
            (change)="fileChange(file.files)" />

          <div *ngIf="viewImageSrcStatus">
            <img [src]="imgURL" style="display: block; margin-top: 3%; height: 60px" />
          </div>
          <div class="mt-3" *ngIf="viewAnyFileStatus">
            <a href="{{ imgURL }}" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-download fa-2x" aria-hidden="true"></i>
              <br />
            </a>
            <span>{{ choosenFileName }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>

      <div class="col-sm-3">
        <button id="updatePersonalDetailsBtn" name="updatePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" *ngIf="modalStatus == 'add'" (click)="onSaveClick()">
          Save
        </button>

        <button id="updateAnnouncementDetail" name="updateAnnouncementDetailBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" *ngIf="modalStatus == 'edit'" (click)="onUpdateClick()">
          Update
        </button>
      </div>

      <div class="col-sm-3">
        <button id="closePersonalDetailsBtn" name="closePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" ngbAutofocus (click)="closeModel()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>